import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { ScheduleGroupEntity } from './schedule-group.entity'

export class ScheduleGroupsRepository extends BaseRepository<ScheduleGroupEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.schedulerApi + '/' + 'schedule-groups', token, cache)
    }
}
